const packageTextData = [
    {
        packageName: "Light",
        packageDay: 7,
        packageExplan: "휴대폰만으로 간편하게<br/>검사를 진행할 수 있어요."
    },
    {
        packageName: "Wave",
        packageDay: 14,
        packageExplan: "집에서도 손가락 채혈 없이<br/>혈당을 확인할 수 있어요."
    },
    {
        packageName: 'Bounce',
        packageDay: 7,
        packageExplan: '일상 속 나의 수면부터 걷기까지의<br/>건강을 모니터링 할 수 있어요.'
    },
    {
        packageName: 'Premium',
        packageDay: 14,
        packageExplan: '헬로에서 제공하는 모든 검사가 포함되어 있어요.<br/>일상에서 손쉽게 건강을 확인하세요!'
    }
];

export default packageTextData;